var _style, _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMerkmalGrueneWelt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "50 50 300 300",
    style: {
      enableBackground: "new 0 0 396.9 396.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#76B82A;}\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    height: 296,
    width: 296,
    x: 273,
    y: -557.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.4,50.4c-81.6,0-148,66.4-148,148s66.4,148,148,148s148-66.4,148-148S280,50.4,198.4,50.4z  M64.3,217.2c7.6-3.8,12.2-10.4,13.9-19.6c1-5.5,5.4-10.4,9.8-13.6c2.3-1.6,4.7-2.9,7.5-3.4c3.2-0.5,6.5-0.2,9.4-1.6 c6.1-3.1,9.6-9.3,15.3-12.9c9.2-5.9,19.3,2.2,28.1-3.3c4.5-2.8,7.3-8.4,4.6-13.4c-2.7-5.1-3.2-10.6,1-14.5 c3.3-3.1,8-4.3,12.5-4.7c7.3-0.6,14.8,0.1,21.7-2.5c10.9-4.1,14.5-14.1,9.1-24c-4.6-8.5-13.6-15.4-16.2-25 c-0.3-1-3-14.3-2.7-14.3c6.5-1,13.2-1.5,20-1.5c40.8,0,77.5,18.2,102.3,46.8l-0.1,0.1c-1.8,2.4-3.5,4.7-5.8,6.4 c-4.6,3.4-7.9,8.2-9.9,14.5c-2.1,6.4-4.5,13.1-9,18.3c-5.1,6-12.9,7-18.3,12.5c-5.5,5.6-9.2,13.2-10.1,21 c-1.1,8.7,3.1,17.6,2.7,26.5c-0.5,9.3-6.9,17.4-1.7,26.6c3.4,6,8.9,10.1,13.7,14.9c5.2,5.2,7.4,12.3,12.5,17.5 c5,5.2,13.5,8.8,20.6,9c4.1,0.2,8-1.1,12.1-1.3c0.3,0,2,0.1,2.1-0.1c-24.5,35.1-65.2,58.1-111.1,58.1 C130.1,333.8,73.5,283,64.3,217.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.8,216.8c0.4,0,0.6-0.2,0.8-0.6c4.1-7.3,13.3-18.8,29.5-18.8c1.4,0,2.9,0.1,4.4,0.3 c10.6,1.3,19.4,8.3,24,19.3c3,7.3,4.1,15.6,3,24c-1.2,9-4.7,17.5-10.2,24.7c-9.7,12.7-41.6,38.5-51.6,38.5 s-41.8-25.8-51.6-38.5c-5.5-7.2-9-15.7-10.2-24.7c-1.1-8.5-0.1-16.8,3-24c4.6-11,13.3-18,24-19.3c1.5-0.2,3-0.3,4.4-0.3 c16.2,0,25.4,11.5,29.5,18.8C162.2,216.5,162.4,216.8,162.8,216.8z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMerkmalGrueneWelt);
export default __webpack_public_path__ + "static/media/icon-merkmal-gruene-welt.f9d778f1751dc94e73349cc31cad916e.svg";
export { ForwardRef as ReactComponent };